import React, { useState } from 'react'
import Container from '../../layout/container'
import { FooterStyle, LogoFooter, FooterColumn } from './style'

import Logo from '../../assets/logo.png'
import Facebook from '../../assets/footer/facebook.svg'
import Instagram from '../../assets/footer/instagram.svg'
import Youtube from '../../assets/footer/youtube.svg'

export default function Footer() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('Enviar');

  const resetForm = () => {
    setEmail('');
    setMessage('¡Gracias!')
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = { email };

    let validEmail = body.email

    if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(validEmail)) {
      try {
        const res = await fetch('/.netlify/functions/createNewsletter', {
          method: 'POST',
          body: JSON.stringify(body),
        });
        console.log(res)
        resetForm();
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <FooterStyle>
      <Container className="container">
        <FooterColumn className="copyright">
          <LogoFooter alt="Boticário" src={Logo} />

          <ul>
            <li>
              <a href="https://www.facebook.com/Emprendedores-OBotic%C3%A1rio-103127941067783/" target="_blank" rel="noopener noreferrer">
                <img src={Facebook} alt="Facebook" title="facebook" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/oboticario.emprendedor/" target="_blank" rel="noopener noreferrer">
                <img src={Instagram} alt="Instagram" title="instagram" />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCwB0FXf8HeGge4_XbdMA8HQ" target="_blank" rel="noopener noreferrer">
                <img src={Youtube} alt="Youtube" title="youtube" />
              </a>
            </li>
          </ul>

          <p>© 2021 OBoticário SA - Todos los derechos reservados</p>
        </FooterColumn>

        <FooterColumn className="links">
          <ul>
            <li>
              <a href="/terminos-condiciones">Términos y condiciones</a>
            </li>
            <li>
              <a href="/anexo-iii-autorizacion-tratamiento-de-datos-personales-para-emprendores-de-boticario-colombia-s-a-s">Tratamiento de datos</a>
            </li>
            <li>
              <a href="/#preguntas">Preguntas frecuentes</a>
            </li>
          </ul>
        </FooterColumn>

        <FooterColumn className="newsletter">
          <h3>Suscríbete a nuestro newsletter</h3>
          <p>Deja tu correo electrónico y recibe consejos de belleza y ofertas exclusivas de la tienda en línea OBoticário.</p>

          <form onSubmit={handleSubmit} noValidate>
            <input type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Tu correo" required />
            <button type="submit">{message}</button>
          </form>
        </FooterColumn>
      </Container>
    </FooterStyle>
  );
}